import * as React from 'react';

import { ProductLabelModel } from '@notino/react-styleguide';
import { IStock } from '@notino/shared/definitions/custom-definitions';

import { ITagsProps } from './model';
import { StyledLabel } from './styled';
import { useCornerTags } from './useCornerTags';

export const CornerTag: React.FC<ITagsProps> = ({
  stockAvailability,
  onClick,
  attributes,
}) => {
  const tagAttribute = useCornerTags({
    attributes: attributes as Record<string, unknown>,
  });

  if (stockAvailability === IStock.outOfStock) {
    return null;
  }

  return (
    tagAttribute && (
      <StyledLabel
        key={tagAttribute.attribute}
        labelStyle={tagAttribute.style}
        icon={tagAttribute.icon}
        labelType={ProductLabelModel.Types.corner}
        className={`pd-variant-tag-${tagAttribute.attribute}`}
        onClick={() => onClick?.(tagAttribute.attribute)}
      >
        {tagAttribute.attribute}
      </StyledLabel>
    )
  );
};
